import TextInput from "../form/TextInput";
import { edit } from "../../slices/settingsSlice";
import Title from "../navigation/Title";
import TextArea from "../form/TextArea";
import React, { useState } from "react";
import { ContentCopy } from "@mui/icons-material";
import { frontendUrl } from "../../utils/fetch";

export default function SettingsSeo(props){
    const { isLoading } = props;

    const [ isCopiedSitemap, setIsCopiedSitemap ] = useState(false);

    const sitemap = `${frontendUrl}sitemap.xml`;

    const copySitemap = () => {
        setIsCopiedSitemap(true);
        setTimeout(() => setIsCopiedSitemap(false), 3000);
        navigator.clipboard.writeText(sitemap);
    }

    return (
        <div className="settings-seo">
            <Title
                title="SEO & Analytics"
                fontSize={22}
                sx={{
                    marginTop: "20px"
                }}
            />
            <div className="settings-card">
                <Title
                    title="Meta tags"
                    fontSize={20}
                    sx={{
                        marginBottom: "10px"
                    }}
                />
                <TextArea
                    label="Description"
                    stateName="settings"
                    valueName="seoDescription"
                    dispatchFunc={edit}
                    disabled={isLoading}
                    description="A brief description of the page that will show up in search results and help attract visitors."
                />
                <TextInput
                    label="Keywords"
                    stateName="settings"
                    valueName="siteKeywords"
                    dispatchFunc={edit}
                    disabled={isLoading}
                    description="Enter relevant keywords separated by commas to help search engines better understand the content of your page."
                />
            </div>
            <div className="settings-card">
                <Title
                    title="Sitemap"
                    fontSize={20}
                    sx={{
                        marginBottom: "10px"
                    }}
                />
                <TextInput
                    label="Sitemap"
                    noRedux
                    noReduxValue={sitemap}
                    noReduxOnChange={() => {}}
                    dispatchFunc={edit}
                    disabled={isLoading}
                    readOnly
                    adornmentIcon={<ContentCopy />}
                    adornmentLabel="Copy link"
                    adornmentOnClick={copySitemap}
                    helperText={isCopiedSitemap && "Sitemap url has been copied!"}
                    description="Link to the site map. Insert this link into webmaster tools such as Google Search Console, Bing Webmaster Tools and other search engines."
                />
            </div>
            <div className="settings-card">
                <Title
                    title="Verification codes"
                    fontSize={20}
                    sx={{
                        marginBottom: "10px"
                    }}
                />
                <TextArea
                    label="Paste code"
                    stateName="settings"
                    valueName="verificationCode"
                    dispatchFunc={edit}
                    disabled={isLoading}
                    description="Insert verification codes for tools such as Google Search Console, Bing Webmaster Tools and other search engines to verify ownership of your site."
                />
            </div>
            <div className="settings-card">
                <Title
                    title="Javascript integration"
                    fontSize={20}
                    sx={{
                        marginBottom: "10px"
                    }}
                />
                <TextArea
                    label="Paste code"
                    stateName="settings"
                    valueName="javascriptIntegration"
                    dispatchFunc={edit}
                    disabled={isLoading}
                    description="Insert custom JavaScript codes such as Google Analytics tracking, integrations for pop-ups, or other analytics tools you want to add to your page."
                />
            </div>
        </div>
    );
}